/* batida-set-card.js: the "set for N people" product card follows the chosen variant (6.10.2026, Halloween w biurze).
   Loaded by sections/product.liquid only for products whose variants have custom.zestaw_dane. Every per-variant piece
   (contents list + summary, the per-person / "osobno" price line) is rendered server-side for each variant with
   data-bset-v="<variant id>"; this shows the chosen one and hides the rest. The chosen variant comes from
   theme:variant:change, and - because Pipeline does not always fire it here (see batida-loyalty.js) - from a re-read of
   the product form's id field shortly after any change or click in the buy box (custom.js writes the new id there),
   with the checked option radio (data-bset-vid) as the fallback. The variant buttons themselves are the theme's own
   radios; nothing here changes the variant. */
(function () {
  'use strict';
  var D = document;

  function known(id) {
    if (!id) return false;
    return !!D.querySelector('[data-bset-v="' + String(id).replace(/[^0-9]/g, '') + '"]');
  }

  function show(id) {
    if (!known(id)) return;
    id = String(id);
    var els = D.querySelectorAll('[data-bset-v]');
    for (var i = 0; i < els.length; i++) els[i].hidden = els[i].getAttribute('data-bset-v') !== id;
  }

  function current() {
    var f = D.querySelector('.product__inner form[action*="/cart/add"] [name="id"]') || D.querySelector('form[action*="/cart/add"] [name="id"]');
    if (f && known(f.value)) return f.value;
    var r = D.querySelector('.product__inner input[type="radio"][data-bset-vid]:checked');
    return r ? r.getAttribute('data-bset-vid') : null;
  }

  D.addEventListener('theme:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) show(v.id);
  });

  var t1 = null, t2 = null;
  function recheck(e) {
    if (e && e.target && e.target.closest && !e.target.closest('.product__inner, .batida-sticky-atc, #batida-sticky-atc-d')) return;
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(function () { show(current()); }, 120);
    t2 = setTimeout(function () { show(current()); }, 600);
  }
  D.addEventListener('change', recheck, true);
  D.addEventListener('click', recheck, true);

  function init() { show(current()); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
